import * as HtmlSanitizer from 'sanitize-text/sanitizers/HtmlSanitizer';
import { jsx as _jsx } from "react/jsx-runtime";
export default function JsonLd({
  item,
  replacer,
  space = 2
}) {
  return /*#__PURE__*/_jsx("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: HtmlSanitizer.formatHtml(JSON.stringify(item, replacer, space), {
        shouldPreventAutoLinker: true
      })
    },
    "data-test-id": "json-ld"
  });
}